import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { Class } from '../../models/Class';

interface DiganosticReportFilters {
  classes: Class[];
  roadmap: { id: string; name: string } | null;
}

export interface filterState {
  value: DiganosticReportFilters;
}

const initialState: filterState = { value: { classes: [], roadmap: null } };

export const filterDiagnosticReportsSlice = createSlice({
  name: 'diagnosticReportsFilter',
  initialState,
  reducers: {
    setDiagnosticReportsFilter: (state: filterState, action: PayloadAction<DiganosticReportFilters>) => {
      state.value = action?.payload;
    },
  },
});

export const selectedDiagnosticReportsFilter = (state: RootState) => state?.diagnosticReportFilters.value;

export const { setDiagnosticReportsFilter } = filterDiagnosticReportsSlice.actions;

export default filterDiagnosticReportsSlice.reducer;
